module.exports = __webpack_public_path__ + "img/hd_01.c55d6d96.png";